import React, { Component } from "react"
import PropTypes from "prop-types"

import { Input, TextArea } from "ui"
import RenderBlockTypeAttributes from "features/editor/attributes/RenderBlockTypeAttributes"

class TextAttribute extends Component {
    render() {
        const { multiline, label, onChange, value, ...otherProps } = this.props
        return !this.props.multiline ? (
            <Input
                type="text"
                className="interactive"
                onChange={ref => this.props.onChange(ref.target.value)}
                placeholder={this.props.label}
                value={value || ""}
                {...RenderBlockTypeAttributes.cleanUpProps(otherProps)}
            />
        ) : (
            <TextArea
                onChange={ref => this.props.onChange(ref.target.value)}
                placeholder={this.props.label}
                value={value || ""}
                {...RenderBlockTypeAttributes.cleanUpProps(otherProps)}
            />
        )
    }
}

TextAttribute.propTypes = {
    multiline: PropTypes.bool,
    label: PropTypes.string,
    onChange: PropTypes.func,
}

export default TextAttribute



// WEBPACK FOOTER //
// ./src/features/editor/attributes/items/form/Text.js